import type { ReactNode } from 'react'

import {
  CommunityCardSlider,
  type TCommunityCardSliderProps,
} from '@/src/features/community/ui/components/CommunityCardSlider'
import type { TSmallTagApi } from '@/src/features/tag/api/types/tagApi.types'
import { TEST_ID } from '@/src/general/constants/testId'
import { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'

import { EVENT_ORIGIN } from '../../../models/community.constants'
import { getCommunitiesCategoryQueryParams, useCommunitiesQuery } from '../../../services/useCommunitiesQuery'

type TFeaturedTagSliderProps = {
  tag: TSmallTagApi
  link?: string
} & Pick<TCommunityCardSliderProps, 'classes' | 'communityCardVariant'>

export const FeaturedTagSlider = ({ classes, tag, link, communityCardVariant }: TFeaturedTagSliderProps): ReactNode => {
  const { data } = useCommunitiesQuery(getCommunitiesCategoryQueryParams(tag.slug))

  return (
    <CommunityCardSlider
      testID={TEST_ID.COMMUNITIES.FEATURED_TAG}
      title={tag.name}
      list={data}
      link={link}
      origin={EVENT_ORIGIN.TAG_SECTION}
      source={TRACKING_SOURCE.TAG_SECTION}
      classes={classes}
      communityCardVariant={communityCardVariant}
    />
  )
}
